export default function About() {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-5xl font-bold text-gray-900 mb-6">About Us</h1>
        <div className="prose prose-lg max-w-none">
          <div className="grid md:grid-cols-2 gap-12 mt-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Mission</h2>
              <p className="text-gray-600 leading-relaxed">
                We are dedicated to providing exceptional service and creating value for our clients 
                through innovation, expertise, and commitment to excellence.
              </p>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Values</h2>
              <ul className="text-gray-600 space-y-2">
                <li className="flex items-start"><span className="text-primary mr-2">✓</span> Integrity and transparency</li>
                <li className="flex items-start"><span className="text-primary mr-2">✓</span> Client-focused approach</li>
                <li className="flex items-start"><span className="text-primary mr-2">✓</span> Continuous improvement</li>
                <li className="flex items-start"><span className="text-primary mr-2">✓</span> Excellence in execution</li>
              </ul>
            </div>
          </div>
        </div>

    </div>
  );
}
